import { memo, useEffect } from "react";
import { FormattedMessage, defineMessages, useIntl } from "react-intl";
import { useSearchParams } from "react-router-dom";

import { useLogout, getEncodedLoginUrlWithSearchParams } from "common/authentication";
import BlockingModal from "common/blocking_modal";
import ModalHeader from "common/blocking_modal/header";
import ModalSubheader from "common/blocking_modal/subheader";
import ModalGraphic from "common/blocking_modal/graphic";
import ModalActions from "common/blocking_modal/actions";
import Button from "common/core/button";
import { segmentTrack } from "util/segment";
import { SEGMENT_EVENTS } from "constants/analytics";
import DocErrorImg from "assets/images/doc-error.svg";
import { useProofRebrand } from "util/feature_detection";

const MESSAGES = defineMessages({
  altTag: {
    id: "88fdafc0-ad84-4945-a32b-9d82f837e756",
    defaultMessage: "Session Expired",
  },
});

function SessionExpiredModal() {
  const [searchParams] = useSearchParams();
  const intl = useIntl();
  const loginUrl = getEncodedLoginUrlWithSearchParams({
    redirectUrl: searchParams.get("returnUrl") || "/",
  });
  const logout = useLogout({ redirectUrl: loginUrl });
  const isProofRebrand = useProofRebrand();
  useEffect(() => {
    segmentTrack(SEGMENT_EVENTS.SESSION_EXPIRED);
  }, []);
  if (isProofRebrand) {
    return (
      <BlockingModal isOpen>
        <ModalHeader>
          <FormattedMessage
            id="a6beefde-3489-4e4d-b1dc-5ac660e07a2a"
            defaultMessage="Your session has expired."
          />
        </ModalHeader>
        <ModalSubheader>
          <FormattedMessage
            id="7b975de7-7255-494f-b7e2-68f5d6462163"
            defaultMessage="In order to keep your information secure, we have logged you out of Proof. Please log in to your Proof account to continue."
          />
        </ModalSubheader>
        <ModalActions>
          <Button onClick={logout} variant="primary" buttonColor="action" buttonSize="large">
            <FormattedMessage id="bae65eee-cbb2-4ab5-acb3-5ad24b1397c1" defaultMessage="Log in" />
          </Button>
        </ModalActions>
      </BlockingModal>
    );
  }
  return (
    <BlockingModal isOpen>
      <ModalGraphic>
        <img alt={intl.formatMessage(MESSAGES.altTag)} src={DocErrorImg} />
      </ModalGraphic>
      <ModalHeader>
        <FormattedMessage
          id="a6beefde-3489-4e4d-b1dc-5ac660e07a2a"
          defaultMessage="Uh oh, session expired"
        />
      </ModalHeader>
      <ModalSubheader>
        <FormattedMessage
          id="7b975de7-7255-494f-b7e2-68f5d6462163"
          defaultMessage="In order to keep your information secure we have logged you out of our app. Please log back into your account to continue."
        />
      </ModalSubheader>
      <ModalActions>
        <Button onClick={logout} variant="secondary" buttonColor="action" buttonSize="large">
          <FormattedMessage
            id="bae65eee-cbb2-4ab5-acb3-5ad24b1397c1"
            defaultMessage="Bring me to login"
          />
        </Button>
      </ModalActions>
    </BlockingModal>
  );
}

export default memo(SessionExpiredModal);
